<div class="subject-select-trigger" [class.list-variant]="variant === 'list'" [matMenuTriggerFor]="readOnly ? null : subjectMenu" role="button" tabindex="0" [attr.aria-label]="selectedSubject?.name ?? ('request_v2.subject.select_subject' | translate)" [class.readonly]="readOnly">
  <span class="subject-name-display">{{ selectedSubject?.name ?? ('request_v2.subject.select_a_subject_placeholder' | translate) }}</span>
  <mat-icon class="chevron-icon" *ngIf="!readOnly">keyboard_arrow_down</mat-icon>
</div>

<mat-menu #subjectMenu="matMenu" panelClass="subject-select-menu-panel">
  <div class="filter-title">{{ 'request_v2.subject.select_subject' | translate }}</div>
  <mat-divider></mat-divider>
  <div class="subject-menu">
    <div class="subject-option" 
        *ngFor="let subject of subjects" 
        (click)="onSubjectSelect(subject._id)">
      <div class="subject-item">
        {{ subject.name }}
      </div>
    </div>
    <div *ngIf="!subjects || subjects.length === 0" class="no-subjects-message-container" (click)="$event.stopPropagation()">
      <span class="no-subjects-message">{{ 'request_v2.subject.no_subjects_available' | translate }}</span>
    </div>
  </div>
</mat-menu>
